import {useFormatAmount, FormatAmountProps} from 'utils/Currency';

const Price = (props: FormatAmountProps) => {
  const formatAmount = useFormatAmount();
  return <>{formatAmount(props)}</>;
};

export default Price;
